import { AppState } from '@modules';

import { DataKeysEnum } from '@containers/OperationBlock/types';

const { my_wallets, cards, blockchain_wallets, my_accounts, transfers } = DataKeysEnum;

const getOperations = (store: AppState) => {
  const { left, right } = store.operationBlock.paymentSelect;

  return {
    sell: left?.group === my_wallets && right?.group === cards,
    sell_with_new_card: left?.group === my_wallets && right?.value === 'new_card',
    withdraw: left?.group === my_wallets && right?.group === blockchain_wallets,
    deposit: left?.group === blockchain_wallets && right?.group === my_wallets,
    buy: left?.group === cards && right?.group === my_wallets,
    buy_with_new_card: left?.value === 'new_card' && right?.group === my_wallets,
    accounts_buy_exchange: left?.group === my_accounts && right?.group === my_wallets,
    accounts_buy_invoice: left?.group === transfers && right?.group === my_wallets,
    accounts_sell_exchange: left?.group === my_wallets && right?.group === my_accounts,
  };
};

export default getOperations;
